module.exports = __webpack_public_path__ + "static/img/index.442b51d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/device/D1000/index.png
// module id = uMLS
// module chunks = 0